import { getConfig } from "owa-service/lib/config";

/**
 * Returns whether the shared coprincipal account functionality is enabled. Which requires the
 * boot flight for persisnce ids to be enabled.
 */
export function isSharedCoprincipalAccountEnabled(): boolean {
    return getConfig().isFeatureEnabled("settings-sharedWithMe", undefined);
}
